import { ContextData } from 'src/app/data/context.data';

export class SheetDateData {

  private _data:any;

  constructor(data:any = null) {
    if (data) {
      this.data = data;
    }
  }

  /**
	 * data
	 */
  public set data(value: any) {
    this._data = value;
  }

  public get x():number {
    return +this._data.x;
  }

  public get y():number {
    return +this._data.y;
  }

  public get rotation():number {
    return +this._data.rotation;
  }

  public get text():string {
    var d:Date = new Date();
    // var date:string = LanguageLibrary.getTextByName("cfg_dateFormat");
    // date = date.replace("@dd@", d.getDate() > 9 ? d.getDate() : "0"+d.getDate());
    // date = date.replace("@mm@", (d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : "0"+(d.getMonth() + 1));
    // date = date.replace("@yyyy@", d.getFullYear());
    return d.toLocaleString();
  }

  public get size():number {
    return +this._data.fontSize;
  }

  public get width():number {
    return +this._data.width;
  }

  public get align():string {
    return this._data.align;
  }

  /**
   * Cleanup
   */
  public cleanup():void {
    this._data = null;
  }
}
